var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportsDarkmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1278 76.7976C18.8481 75.808 17.8023 73.1576 18.7919 70.8779L31.7066 41.1278C32.6962 38.8481 35.3466 37.8023 37.6263 38.7919C39.9061 39.7816 40.9519 42.4319 39.9623 44.7117L27.0476 74.4617C26.0579 76.7414 23.4076 77.7873 21.1278 76.7976Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6277 60.7661C60.348 59.7763 59.3024 57.1258 60.2922 54.8462L73.1957 25.1277C74.1855 22.848 76.8359 21.8024 79.1156 22.7922C81.3953 23.782 82.4409 26.4324 81.4511 28.7121L68.5476 58.4306C67.5578 60.7103 64.9074 61.7559 62.6277 60.7661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4181 39.4876C29.4575 37.2301 32.1301 36.2426 34.3876 37.282L67.9014 52.7122C70.1589 53.7516 71.1464 56.4242 70.107 58.6817C69.0676 60.9392 66.395 61.9267 64.1375 60.8873L30.6237 45.4571C28.3662 44.4177 27.3787 41.7451 28.4181 39.4876Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 72C32 76.9706 27.9706 81 23 81C18.0294 81 14 76.9706 14 72C14 67.0294 18.0294 63 23 63C27.9706 63 32 67.0294 32 72Z",
    fill: "#EB6087"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43C44.5 47.9706 40.4706 52 35.5 52C30.5294 52 26.5 47.9706 26.5 43C26.5 38.0294 30.5294 34 35.5 34C40.4706 34 44.5 38.0294 44.5 43Z",
    fill: "#EB6087"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 56C73.5 60.9706 69.4706 65 64.5 65C59.5294 65 55.5 60.9706 55.5 56C55.5 51.0294 59.5294 47 64.5 47C69.4706 47 73.5 51.0294 73.5 56Z",
    fill: "#EB6087"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86 27C86 31.9706 81.9706 36 77 36C72.0294 36 68 31.9706 68 27C68 22.0294 72.0294 18 77 18C81.9706 18 86 22.0294 86 27Z",
    fill: "#EB6087"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportsDarkmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reports-darkmode.bd9fef5e94ea1a7c9886e750ed713426.svg";